module.exports = __webpack_public_path__ + "static/media/cough-cold.4748df38.svg";